import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { EventDetailsService } from '../event-details/event-details.service';
import { AllEventsResponseModel, EventResponseModel, SingleEventResponseModel } from './dto/event-response-module';
import { EventDTO, EventPagDto, EventRSVPDto, EventStatusDTO, EventUpdateDTO, GetEventDTO } from './dto/event.dto';
import { EventsEntity } from './event.entity';
import * as fs from 'fs';
import { EventFilesEntity } from './event-files.entity';
import { ProfileEntity } from '../profile/profile.entity';
import { EventRSVPEntity } from './event-rsvp.entity';
import { env } from 'process';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { sendFCMNotifications } from '../shared/mobileOTP';
import { UserEntity } from '../user/user.entity';
import { PostEntity } from '../post/post.entity';

@Injectable()
export class EventService {    
    constructor(
        @InjectRepository(EventsEntity)
        private eventRepository: Repository<EventsEntity>,
        @InjectRepository(EventFilesEntity)
        private eventFilesRepo: Repository<EventFilesEntity>,
        @InjectRepository(EventRSVPEntity)
        private eventRSVPRepo: Repository<EventRSVPEntity>,
        @InjectRepository(ProfileEntity)
        private profileRepo: Repository<ProfileEntity>,
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>,
        @InjectRepository(UserEntity)
        private userRepo:Repository<UserEntity>,
        @InjectRepository(PostEntity)
        private postRepo:Repository<PostEntity>,
        private eventDetailsService:EventDetailsService,
    ) {}

    async sendNotify(text) {
        return await sendFCMNotifications(text)
        .then(() => {      
          console.log('notification sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending notification ', err);
          return false;
        });
    }

    
    async createEventWithData(queryParams, eventDto:EventDTO) {
        try {
            if(queryParams.apiVersion == 1) {
                eventDto.createdUser = eventDto.userId;
                const saveEvent = await this.eventRepository.save(eventDto);
                if(saveEvent) {
                    const allUsr = await this.userRepo.find({
                        where:{status:true}
                    })
                    if(allUsr) {
                        allUsr.map((u) => {
                            if(u.fcmToken != null) {
                                let msg = {
                                    to : `${u.fcmToken}`,
                                    collapse_key : "type_a",
                                    notification : {
                                      body : `A New Event Created with ${saveEvent.Id}`,
                                      title: "Create Event"
                                    },
                                    data : {
                                      body : `A New Event Created with ${saveEvent.Id}`,
                                      title: "Create Event",
                                      key_1 : "",
                                      key_2 : ""
                                    }
                                }
                                this.notifyRepo.save({
                                    title:'Create Event',
                                    message:`A New Event Created with ${saveEvent.Id}`,
                                    typeId:6,
                                    userId:u.Id,
                                    targetId:saveEvent.Id,
                                    status:true
                                })
                                if(u.fcmToken) {                  
                                    this.sendNotify(msg);
                                }
                            }
                        })
                    }
                    if(eventDto.guestIds) {
                        var dataToPost = eventDto.guestIds.split(',').map((el) => {
                            return {
                                eventId:saveEvent.Id,
                                guestId: parseInt(el),
                                createdUser:eventDto.userId
                            };
                        });
                        const savedActivity = await this.eventDetailsService.createGuestUsers(dataToPost);
                    }
                    return saveEvent;
                } else {
                    return null;
                }
            } else {
                eventDto.createdUser = eventDto.userId;
                const saveEvent = await this.eventRepository.save(eventDto);
                if(saveEvent) {
                    const allUsr = await this.userRepo.find({
                        where:{status:true}
                    })
                    if(allUsr) {
                        allUsr.map((u) => {
                            if(u.fcmToken != null) {
                                let msg = {
                                    to : `${u.fcmToken}`,
                                    collapse_key : "type_a",
                                    notification : {
                                      body : `A New Event Created with ${saveEvent.Id}`,
                                      title: "Create Event"
                                    },
                                    data : {
                                      body : `A New Event Created with ${saveEvent.Id}`,
                                      title: "Create Event",
                                      key_1 : "",
                                      key_2 : ""
                                    }
                                }
                                this.notifyRepo.save({
                                    title:'Create Event',
                                    message:`A New Event Created with ${saveEvent.Id}`,
                                    typeId:6,
                                    userId:u.Id,
                                    targetId:saveEvent.Id,
                                    status:true
                                })
                                if(u.fcmToken) {                  
                                    this.sendNotify(msg);
                                }
                            }
                        })
                    }
                    if(eventDto.guestIds) {
                        var dataToPost = eventDto.guestIds.split(',').map((el) => {
                            return {
                                eventId:saveEvent.Id,
                                guestId: parseInt(el),
                                createdUser:eventDto.userId
                            };
                        });
                        const savedActivity = await this.eventDetailsService.createGuestUsers(dataToPost);
                    }
                    return saveEvent;
                } else {
                    return null;
                }
            }
        } catch (error) {
            throw error;
        }
    }

    async createEventPostWithData(queryParams, eventDto:EventDTO) {
        try {
            if(queryParams.apiVersion == 1) {
                const saveEvent = await this.postRepo.save({
                    text:eventDto.eventTitle,
                    villageId:eventDto.villageId,
                    postTypeId:1,
                    userId:eventDto.userId,
                    status:2,
                    createdUser:eventDto.userId,
                    versionFlag:eventDto.versionFlag
                });
                if(saveEvent) {
                    return saveEvent;
                } else {
                    return null;
                }
            } else {
                const saveEvent = await this.postRepo.save({
                    text:eventDto.eventTitle,
                    villageId:eventDto.villageId,
                    postTypeId:1,
                    userId:eventDto.userId,
                    status:2,
                    createdUser:eventDto.userId,
                    versionFlag:eventDto.versionFlag
                });
                if(saveEvent) {
                    return saveEvent;
                } else {
                    return null;
                }
            }
        } catch (error) {
            throw error;
        }
    }
    async createEventAttachments(queryParams, filesData, eventId):Promise<EventResponseModel> {
        const response = new EventResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const savedData = await this.eventFilesRepo.save(filesData);
                if(savedData) {
                    const fData = await this.eventRepository.findOne({
                        relations:['user','eventcategory'],
                        where:{Id:eventId}
                    });
                    response.status = true;
                    response.data = fData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Event created  successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Event creation failed')
                }
            } else {
                const savedData = await this.eventFilesRepo.save(filesData);
                if(savedData) {
                    const fData = await this.eventRepository.findOne({
                        relations:['user','eventcategory'],
                        where:{Id:eventId}
                    });
                    response.status = true;
                    response.data = fData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Event created  successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Event creation failed')
                }
            }
            return response;
        } catch(error) {
            throw error;
        }
    }

    async getAllEvents(evenPagDto:EventPagDto, userId, request:Request):Promise<AllEventsResponseModel> {
        const response = new AllEventsResponseModel();
        try {
            const finData: any[] = [];
            let images: any[] = [];
            if(evenPagDto.apiVersion == 1) {
                const userData = await this.profileRepo.findOne({
                    where:{userId:userId}
                })
                /* if(userData.villageId > 0) {
                    var savedData = await this.eventRepository.find({
                        relations:['user','user.profile','eventcategory','village'],                   
                        where:{status: true,villageId: userData.villageId},
                        order: {createdAt: "DESC"},
                        skip:evenPagDto.skip,
                        take: 10
                    });
                } else { */
                    var savedData = await this.eventRepository.find({
                        relations:['user','user.profile','eventcategory','village'],                   
                        where:{status: true},
                        order: {createdAt: "DESC"},
                        skip:evenPagDto.skip,
                        take: 10
                    });
                //}                
                if(savedData) {
                    const promises = savedData.map(async (evn) => {
                        const eventImages = await this.eventFilesRepo.find({
                            where:{eventId:evn.Id}
                        }) 
                        const userInvited = await this.eventDetailsService.checkGuestUser(userId,evn.Id);
                        const userInviteCount = await this.eventDetailsService.GuestUserCount(evn.Id);
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:userId,eventId:evn.Id}
                        }) 
                        console.log('resvp',rsvpinfo);
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:evn.Id}
                        })
                        console.log('resvp',yesUsers);
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:evn.Id}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:evn.Id}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        return {
                            eventId: evn.Id,
                            category:evn.eventcategory.category,
                            eventTitle: evn.eventTitle,
                            eventDesc: evn.eventDesc,
                            place:evn.village != null ? evn.village.villageName:' ',
                            startDate:evn.eventStartDate,
                            startTime:evn.eventStartTime,
                            endDate:evn.eventEndDate,
                            endTime:evn.eventEndTime,
                            public: evn.public == 1?true:false,
                            userId:evn.userId,
                            userName:evn.user.profile.firstName != null ? evn.user.profile.firstName :'',
                            profilePic:evn.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${evn.user.profile.profilePic}` : '',
                            userInvited:userInvited == null?false:true,
                            InvitedUserCount:userInviteCount.length,
                            rsvp:rsvp,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            eventImages:eventImages
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        if(f.eventImages) {
                            f.eventImages.map((i) => {
                                images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                            })
                        }
                        finData.push({
                            eventId: f.eventId,
                            category:f.category,
                            eventTitle: f.eventTitle,
                            eventDesc: f.eventDesc,
                            place:f.place,
                            startDate:f.startDate,
                            startTime:f.startTime,
                            endDate:f.endDate,
                            endTime:f.endTime,
                            public: f.public,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic:f.profilePic,
                            userInvited:f.userInvited,
                            InvitedUserCount:f.InvitedUserCount,
                            rsvp:f.rsvp,
                            yesRSVP:f.yesRSVP,
                            mayBeRSVP:f.mayBeRSVP,
                            noRSVP:f.noRSVP,
                            eventImages:images
                        })
                        images=[];
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const userData = await this.profileRepo.findOne({
                    where:{userId:userId}
                })
                /* if(userData.villageId > 0) {
                    var savedData = await this.eventRepository.find({
                        relations:['user','user.profile','eventcategory','village'],                   
                        where:{status: true,villageId: userData.villageId},
                        order: {createdAt: "DESC"},
                        skip:evenPagDto.skip,
                        take: 10
                    });
                } else { */
                    var savedData = await this.eventRepository.find({
                        relations:['user','user.profile','eventcategory','village'],                   
                        where:{status: true},
                        order: {createdAt: "DESC"},
                        skip:evenPagDto.skip,
                        take: 10
                    });
               // }                
                if(savedData) {
                    const promises = savedData.map(async (evn) => {
                        const eventImages = await this.eventFilesRepo.find({
                            where:{eventId:evn.Id}
                        }) 
                        const userInvited = await this.eventDetailsService.checkGuestUser(userId,evn.Id);
                        const userInviteCount = await this.eventDetailsService.GuestUserCount(evn.Id);
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:userId,eventId:evn.Id}
                        }) 
                        console.log('resvp',rsvpinfo);
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:evn.Id}
                        })
                        console.log('resvp',yesUsers);
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:evn.Id}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:evn.Id}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        return {
                            eventId: evn.Id,
                            category:evn.eventcategory.category,
                            eventTitle: evn.eventTitle,
                            eventDesc: evn.eventDesc,
                            place:evn.village != null ? evn.village.villageName:' ',
                            startDate:evn.eventStartDate,
                            startTime:evn.eventStartTime,
                            endDate:evn.eventEndDate,
                            endTime:evn.eventEndTime,
                            public: evn.public == 1?true:false,
                            userId:evn.userId,
                            userName:evn.user.profile.firstName != null ? evn.user.profile.firstName :'',
                            profilePic:evn.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${evn.user.profile.profilePic}` : '',
                            userInvited:userInvited == null?false:true,
                            InvitedUserCount:userInviteCount.length,
                            rsvp:rsvp,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            eventImages:eventImages
                        }
                    })
                    const da = await Promise.all(promises);
                    da.map((f) => {  
                        if(f.eventImages) {
                            f.eventImages.map((i) => {
                                images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                            })
                        }
                        finData.push({
                            eventId: f.eventId,
                            category:f.category,
                            eventTitle: f.eventTitle,
                            eventDesc: f.eventDesc,
                            place:f.place,
                            startDate:f.startDate,
                            startTime:f.startTime,
                            endDate:f.endDate,
                            endTime:f.endTime,
                            public: f.public,
                            userId:f.userId,
                            userName:f.userName,
                            profilePic:f.profilePic,
                            userInvited:f.userInvited,
                            InvitedUserCount:f.InvitedUserCount,
                            rsvp:f.rsvp,
                            yesRSVP:f.yesRSVP,
                            mayBeRSVP:f.mayBeRSVP,
                            noRSVP:f.noRSVP,
                            eventImages:images
                        })
                        images=[];
                    }); 
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getEventByEventId(queryParams,eventId, request):Promise<SingleEventResponseModel> {
        const response = new SingleEventResponseModel();
        try {
            let images: any[] = [];
            if(queryParams.apiVersion == 1) {
                const savedData = await this.eventRepository.findOne({ 
                    relations:['user','user.profile','eventcategory','village'],                   
                    where:{Id:eventId,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(savedData) {
                    const eventImages = await this.eventFilesRepo.find({
                        where:{eventId:eventId}
                    }) 
                    if(eventImages) {
                        eventImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    }
                    //const userInvited = await this.eventDetailsService.checkGuestUser(userId,evn.Id);                
                    let final = {
                        eventId: savedData.Id,
                        category:savedData.eventcategory.category,
                        eventTitle: savedData.eventTitle,
                        eventDesc: savedData.eventDesc,
                        place:savedData.village != null ? savedData.village.villageName:' ',
                        startDate:savedData.eventStartDate,
                        startTime:savedData.eventStartTime,
                        endDate:savedData.eventEndDate,
                        endTime:savedData.eventEndTime,
                        public: savedData.public==1?true:false,
                        userId:savedData.userId,
                        userName:savedData.user.profile.firstName != null ? savedData.user.profile.firstName :'',
                        profilePic:savedData.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${savedData.user.profile.profilePic}` : '',
                        eventImages:images
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const savedData = await this.eventRepository.findOne({ 
                    relations:['user','user.profile','eventcategory','village'],                   
                    where:{Id:eventId,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(savedData) {
                    const eventImages = await this.eventFilesRepo.find({
                        where:{eventId:eventId}
                    }) 
                    if(eventImages) {
                        eventImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    }
                    let final = {
                        eventId: savedData.Id,
                        category:savedData.eventcategory.category,
                        eventTitle: savedData.eventTitle,
                        eventDesc: savedData.eventDesc,
                        place:savedData.village != null ? savedData.village.villageName:' ',
                        startDate:savedData.eventStartDate,
                        startTime:savedData.eventStartTime,
                        endDate:savedData.eventEndDate,
                        endTime:savedData.eventEndTime,
                        public: savedData.public==1?true:false,
                        userId:savedData.userId,
                        userName:savedData.user.profile.firstName != null ? savedData.user.profile.firstName :'',
                        profilePic:savedData.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${savedData.user.profile.profilePic}` : '',
                        eventImages:images
                    }
                    response.status = true;
                    response.data = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
    
    async updateEvent(queryParams, filedata,eventUpdateDTO: EventUpdateDTO, request:Request): Promise<SingleEventResponseModel> {
        const response = new SingleEventResponseModel();
        try {
            let images: any[] = [];
            const oldData = await this.eventRepository.findOne({
                where:{Id:eventUpdateDTO.Id}
            })
            if(eventUpdateDTO.eventTitle) {
                eventUpdateDTO.eventTitle = eventUpdateDTO.eventTitle
            } else {
                eventUpdateDTO.eventTitle= oldData.eventTitle
            }
            if(eventUpdateDTO.eventDesc) {
                eventUpdateDTO.eventDesc  = eventUpdateDTO.eventDesc
            } else {
                eventUpdateDTO.eventDesc = oldData.eventDesc
            }
            if(eventUpdateDTO.villageId) {
                eventUpdateDTO.villageId = eventUpdateDTO.villageId
            } else {
                eventUpdateDTO.villageId = oldData.villageId
            }
            if(eventUpdateDTO.categoryId) {
                eventUpdateDTO.categoryId = eventUpdateDTO.categoryId
            } else {
                eventUpdateDTO.categoryId = oldData.categoryId
            }
            if(eventUpdateDTO.eventStartDate) {
                eventUpdateDTO.eventStartDate = eventUpdateDTO.eventStartDate
            } else {
                eventUpdateDTO.eventStartDate = oldData.eventStartDate
            }
            if(eventUpdateDTO.eventStartTime) {
                eventUpdateDTO.eventStartTime = eventUpdateDTO.eventStartTime
            } else {
                eventUpdateDTO.eventStartTime = oldData.eventStartTime
            }
            if(eventUpdateDTO.eventEndDate) {
                eventUpdateDTO.eventEndDate = eventUpdateDTO.eventEndDate
            } else {
                eventUpdateDTO.eventEndDate = oldData.eventEndDate
            }
            if(eventUpdateDTO.eventEndTime) {
                eventUpdateDTO.eventEndTime = eventUpdateDTO.eventEndTime
            } else {
                eventUpdateDTO.eventEndTime = oldData.eventEndTime
            }
            if(eventUpdateDTO.public) {
                eventUpdateDTO.public = eventUpdateDTO.public
            } else {
                eventUpdateDTO.public = oldData.public
            }
            if(eventUpdateDTO.versionFlag) {
                eventUpdateDTO.versionFlag = eventUpdateDTO.versionFlag
            } else {
                eventUpdateDTO.versionFlag = oldData.versionFlag
            } 
            eventUpdateDTO.updatedUser = eventUpdateDTO.userId
            let finaObj = {
                eventTitle:eventUpdateDTO.eventTitle,
                eventDesc:eventUpdateDTO.eventDesc,
                villageId:eventUpdateDTO.villageId,
                categoryId:eventUpdateDTO.categoryId,
                eventStartDate:eventUpdateDTO.eventStartDate,
                eventStartTime:eventUpdateDTO.eventStartTime,
                eventEndDate:eventUpdateDTO.eventEndDate,
                eventEndTime:eventUpdateDTO.eventEndTime,
                public:eventUpdateDTO.public,
                userId:eventUpdateDTO.userId,
                versionFlag:eventUpdateDTO.versionFlag,
                updatedUser:eventUpdateDTO.updatedUser
            }
            if(queryParams.apiVersion == 1) {
                eventUpdateDTO.updatedUser = eventUpdateDTO.userId;
                const updatePostType = await this.eventRepository.update(eventUpdateDTO.Id, finaObj);
                const oldFiles = await this.eventFilesRepo.find({where:{eventId:eventUpdateDTO.Id}})
                if(oldFiles) {
                    oldFiles.map((f) => {
                        var fname = f.fileUrl.split('/')[2];
                        fs.unlinkSync('./public/eventPics/'+fname);
                    })                    
                    await this.eventFilesRepo.delete({eventId:eventUpdateDTO.Id});
                } 
                await this.eventFilesRepo.save(filedata);
                if(eventUpdateDTO.guestIds) {
                    const delPrevious = await this.eventDetailsService.deleteGuestUsers(eventUpdateDTO.Id)
                    var dataToPost = eventUpdateDTO.guestIds.split(',').map((el) => {
                        return {
                            eventId:eventUpdateDTO.Id,
                            guestId: parseInt(el),
                            createdUser:eventUpdateDTO.userId
                        };
                    });
                    const savedActivity = await this.eventDetailsService.createGuestUsers(dataToPost);
                }    
                const updatedData = await this.eventRepository.findOne({ 
                    relations:['user','user.profile','eventcategory','village'],                   
                    where:{Id:eventUpdateDTO.Id}
                });
                if(updatePostType) {
                    const eventImages = await this.eventFilesRepo.find({
                        where:{eventId:eventUpdateDTO.Id}
                    }) 
                    if(eventImages) {
                        eventImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    }
                    let final = {
                        eventId: updatedData.Id,
                        category:updatedData.eventcategory.category,
                        eventTitle: updatedData.eventTitle,
                        eventDesc: updatedData.eventDesc,
                        place:updatedData.village != null ? updatedData.village.villageName:' ',
                        startDate:updatedData.eventStartDate,
                        endDate:updatedData.eventEndDate,
                        public: updatedData.public==1?true:false,
                        userId:updatedData.userId,
                        userName:updatedData.user.profile.firstName != null ? updatedData.user.profile.firstName :'',
                        profilePic:updatedData.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.user.profile.profilePic}` : '',
                        eventImages:images
                    }
                    response.status = true;
                    response.data   = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'event updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'event update failed')
                }
            } else {
                eventUpdateDTO.updatedUser = eventUpdateDTO.userId;
                const updatePostType = await this.eventRepository.update(eventUpdateDTO.Id, finaObj);
                const oldFiles = await this.eventFilesRepo.find({where:{eventId:eventUpdateDTO.Id}})
                if(oldFiles) {
                    oldFiles.map((f) => {
                        var fname = f.fileUrl.split('/')[2];
                        fs.unlinkSync('./public/eventPics/'+fname);
                    })                    
                    await this.eventFilesRepo.delete({eventId:eventUpdateDTO.Id});
                } 
                await this.eventFilesRepo.save(filedata);
                if(eventUpdateDTO.guestIds) {
                    const delPrevious = await this.eventDetailsService.deleteGuestUsers(eventUpdateDTO.Id)
                    var dataToPost = eventUpdateDTO.guestIds.split(',').map((el) => {
                        return {
                            eventId:eventUpdateDTO.Id,
                            guestId: parseInt(el),
                            createdUser:eventUpdateDTO.userId
                        };
                    });
                    const savedActivity = await this.eventDetailsService.createGuestUsers(dataToPost);
                }    
                const updatedData = await this.eventRepository.findOne({ 
                    relations:['user','user.profile','eventcategory','village'],                   
                    where:{Id:eventUpdateDTO.Id}
                });
                if(updatePostType) {
                    const eventImages = await this.eventFilesRepo.find({
                        where:{eventId:eventUpdateDTO.Id}
                    }) 
                    if(eventImages) {
                        eventImages.map((i) => {
                            images.push(`${process.env.WORKINGURL}/${i.fileUrl}`)
                        })
                    }
                    let final = {
                        eventId: updatedData.Id,
                        category:updatedData.eventcategory.category,
                        eventTitle: updatedData.eventTitle,
                        eventDesc: updatedData.eventDesc,
                        place:updatedData.village != null ? updatedData.village.villageName:' ',
                        startDate:updatedData.eventStartDate,
                        endDate:updatedData.eventEndDate,
                        public: updatedData.public==1?true:false,
                        userId:updatedData.userId,
                        userName:updatedData.user.profile.firstName != null ? updatedData.user.profile.firstName :'',
                        profilePic:updatedData.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.user.profile.profilePic}` : '',
                        eventImages:images
                    }
                    response.status = true;
                    response.data   = final;
                    response.statusCode = 50000;
                    response.internalMessage = 'event updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'event update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateEventStatus(queryParams, eventStatusDTO:EventStatusDTO, request:Request): Promise<EventResponseModel> {
        const response = new EventResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatePostType = await this.eventRepository.update(eventStatusDTO.Id, eventStatusDTO);
                const updatedData = await this.eventRepository.findOne({
                    where:{Id:eventStatusDTO.Id}
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'event updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'event update failed')
                }
            } else {
                const updatePostType = await this.eventRepository.update(eventStatusDTO.Id, eventStatusDTO);
                const updatedData = await this.eventRepository.findOne({
                    where:{Id:eventStatusDTO.Id}
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'event updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'event update failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async eventRSVP(queryParams, eventrsvpDTO:EventRSVPDto, request:Request):Promise<EventResponseModel> {
        const response = new EventResponseModel();
        try {
            const checkRSVP = await this.eventRSVPRepo.findOne({
                where:{userId:eventrsvpDTO.userId,eventId:eventrsvpDTO.eventId}
            })
            if(queryParams.apiVersion == 1) {
                if(checkRSVP) {
                    const saved = await this.eventRSVPRepo.update({Id:checkRSVP.Id},{rsvp:eventrsvpDTO.rsvp})
                    if(saved) {
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:eventrsvpDTO.userId,eventId:eventrsvpDTO.eventId}
                        }) 
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:eventrsvpDTO.eventId}
                        })
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:eventrsvpDTO.eventId}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:eventrsvpDTO.eventId}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        response.status = true;
                        response.data = {
                            Id:eventrsvpDTO.eventId,
                            userId:eventrsvpDTO.userId,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            rsvp:rsvp
                        }
                        response.statusCode = 50000;
                        response.internalMessage = 'Event RSVP changed successfully';
                        response.intlCode = 11100;                    
                    }  else { 
                        throw new ErrorResponse(11106, 'Event RSVP not changed')
                    }
                } else {
                    const saved = await this.eventRSVPRepo.save(eventrsvpDTO);
                    if(saved) {
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:eventrsvpDTO.userId,eventId:eventrsvpDTO.eventId}
                        }) 
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:eventrsvpDTO.eventId}
                        })
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:eventrsvpDTO.eventId}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:eventrsvpDTO.eventId}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        response.status = true;
                        response.data = {
                            Id:eventrsvpDTO.eventId,
                            userId:eventrsvpDTO.userId,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            rsvp:rsvp
                        }
                        response.statusCode = 50000;
                        response.internalMessage = 'Event RSVP saved successfully';
                        response.intlCode = 11100;                    
                    }  else { 
                        throw new ErrorResponse(11106, 'Event RSVP not saved')
                    }
                }                
                           
            } else {
                if(checkRSVP) {
                    const saved = await this.eventRSVPRepo.update({Id:checkRSVP.Id},{rsvp:eventrsvpDTO.rsvp})
                    if(saved) {
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:eventrsvpDTO.userId,eventId:eventrsvpDTO.eventId}
                        }) 
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:eventrsvpDTO.eventId}
                        })
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:eventrsvpDTO.eventId}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:eventrsvpDTO.eventId}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        response.status = true;
                        response.data = {
                            Id:eventrsvpDTO.eventId,
                            userId:eventrsvpDTO.userId,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            rsvp:rsvp
                        }
                        response.statusCode = 50000;
                        response.internalMessage = 'Event RSVP changed successfully';
                        response.intlCode = 11100;                    
                    }  else { 
                        throw new ErrorResponse(11106, 'Event RSVP not changed')
                    }
                } else {
                    const saved = await this.eventRSVPRepo.save(eventrsvpDTO);
                    if(saved) {
                        const rsvpinfo = await this.eventRSVPRepo.findOne({
                            where:{userId:eventrsvpDTO.userId,eventId:eventrsvpDTO.eventId}
                        }) 
                        const yesUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:1,eventId:eventrsvpDTO.eventId}
                        })
                        const mayBeUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:2,eventId:eventrsvpDTO.eventId}
                        })  
                        const noUsers = await this.eventRSVPRepo.find({
                            where:{rsvp:3,eventId:eventrsvpDTO.eventId}
                        })       
                        if(rsvpinfo) {
                            var rsvp = rsvpinfo.rsvp;
                        } else {
                            var rsvp = 0;
                        }
                        response.status = true;
                        response.data = {
                            Id:eventrsvpDTO.eventId,
                            userId:eventrsvpDTO.userId,
                            yesRSVP:yesUsers.length,
                            mayBeRSVP:mayBeUsers.length,
                            noRSVP:noUsers.length,
                            rsvp:rsvp
                        }
                        response.statusCode = 50000;
                        response.internalMessage = 'Event RSVP saved successfully';
                        response.intlCode = 11100;                    
                    }  else { 
                        throw new ErrorResponse(11106, 'Event RSVP not saved')
                    }
                }                
                           
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
